import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import classNames from "classnames";
import { areBundleOptionsFromOrder } from "@jti/magento";
import { useTranslations } from "@jti/ui";
import { OrderSummaryListItem } from "./OrderSummaryListItem";
import styles from "./OrderSummaryItemsList.module.scss";
const MAX_ITEMS_PER_VIEW = 3;
export const OrderSummaryItemsList = ({ items = [], className }) => {
    const { __ } = useTranslations();
    const modifiedItems = useMemo(() => items?.reduce((acc, item) => {
        const isSubscribed = item?.subscription === 1;
        if (item.product_type === "bundle" && item?.bundle_options) {
            item.bundle_options.forEach(({ values }) => {
                values &&
                    areBundleOptionsFromOrder(values) &&
                    values.forEach((value) => {
                        const { product } = value.presentation_info || {};
                        acc.push({
                            item_id: value.id,
                            name: value.product_name,
                            quantity: value.quantity,
                            imageUrl: product?.small_image?.url,
                            isSubscribed,
                        });
                    });
            });
            return acc;
        }
        return [
            ...acc,
            {
                item_id: item.item_id,
                name: item.name,
                quantity: item.quantity,
                imageUrl: item.imageUrl,
                isSubscribed,
            },
        ];
    }, []), [items]);
    const isMoreItemsAvailable = modifiedItems.length > MAX_ITEMS_PER_VIEW;
    const itemsToDisplay = isMoreItemsAvailable ? modifiedItems.slice(0, 2) : modifiedItems;
    const restItemsCount = modifiedItems.length - 2;
    return (_jsxs("div", { className: classNames(styles.orderSummaryItemsList, className), children: [itemsToDisplay.map(({ imageUrl, item_id, name, isSubscribed, quantity }) => {
                return (_jsx(OrderSummaryListItem, { quantity: quantity, isSubscribed: isSubscribed, productName: name, imageUrl: imageUrl }, item_id || name));
            }), isMoreItemsAvailable && (_jsx("span", { className: styles.moreItems, children: __("cart.order.summary.moreItems", [restItemsCount]) }))] }));
};
//# sourceMappingURL=OrderSummaryItemsList.js.map